import React from 'react';

const placements = {
  default: {
    topSkip: 1,
    bottomSkip: 1,
    distance: 3,
  }
}

export default function AdsSsrPlacement({
  index,
  subbuzzes
}) {

  const { topSkip, bottomSkip, distance } = placements.default;

  // place an ad every `distance` subbuzzes, starting after `topSkip`, leaving `bottomSkip` subbuzzes free at the end
  if (
    index >= topSkip &&
    (index - topSkip) % distance === 0 &&
    index + bottomSkip < subbuzzes?.length
  ) {
    return (
      <div className='js-ssr-ad-placement'></div>
    );
  }

  return null;
}
